import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';
import { FallaufgabenService } from '../services/fallaufgaben-service';
import { Status } from '../services/status';

export const sessionsResolver: ResolveFn<boolean> = async (route, state) => {
  const statusService = inject(Status);
  const fallaufgabenService = inject(FallaufgabenService);

  try {
    if (statusService.status.length === 0) await statusService.get();
    if (fallaufgabenService.fallaufgaben.length === 0) await fallaufgabenService.list();
    if (route.params['fallaufgabenid']) {
      statusService.filteredStatus = statusService.status.filter(s => s.fallaufgabenId === route.params['fallaufgabenid']);
      fallaufgabenService.set(route.params['fallaufgabenid']);
    }
    return true;
  } catch (error) {
    console.warn(error);
    return false;
  }
};
